import { CreateOrderBody } from '../api/v1/spot'

export interface OrderManagerData extends Partial<CreateOrderBody> {
  isClose?: boolean
}
export class OrderManager {
  private static orders: Map<string, OrderManagerData> = new Map()

  public static addOrder(
    clientOrderId: string,
    orderData: OrderManagerData,
  ): void {
    this.orders.set(clientOrderId, orderData)
  }

  public static getOrder(clientOrderId: string): OrderManagerData | undefined {
    return this.orders.get(clientOrderId)
  }

  // Query whether the order is a close position order
  public static isCloseOrder(clientOrderId: string): boolean {
    return !!this.orders.get(clientOrderId)?.isClose
  }
}
